module.exports = __webpack_public_path__ + "img/guest-access-old.b1c16770.png";